import axios from 'axios'

export class Kassenprojekt{
    static async get(konvKey, timeout = 1500){
        try {
            const response = await axios.get(
              'https://feuerwehr-server.org:5000/kassenprojekte', { params: { konvKey: konvKey }, timeout }
            );
              console.log(response.data);
              return response.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
    static async add(projektData){
        try{
            const response = await axios.post('https://feuerwehr-server.org:5000/addKassenprojekt', projektData);
            console.log(response.data);
            return true;
        } catch(err){
            console.error(err);
            return false;
        }
    }
    static async update(kassenprojekt, timeout = 1500){
        try {
            const response = await axios.put('https://feuerwehr-server.org:5000/updateKassenprojekt', kassenprojekt,{timeout});
            console.log(response.data);
            console.log(response);
            return true;
        } catch (err) {
            console.error(err);
            throw err;
        }
    }
    static async delete(projekt){
        try{
            const response = await axios.delete(
                'https://feuerwehr-server.org:5000/deleteKassenprojekt',
                { params: { kassenProjektID: projekt.kassenProjektID, feuerwehrID: projekt.feuerwehrID } }
            );
            console.log(response.data);
            return true;
        } catch (err){
            console.log(err);
            return false;
        }
    }
}